import stylesheet from './RichTextColumns.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';

const COLUMNS_ATTRIBUTES = ['columns', 'columns-md', 'columns-lg', 'columns-xl', 'columns-xxl'] as const;

class NXTRichTextColumns extends CustomComponent {
    static readonly observedAttributes = [...COLUMNS_ATTRIBUTES];

    private rootElement: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    setColumnsProperties(element: HTMLElement) {
        COLUMNS_ATTRIBUTES.forEach((attr) => {
            element.style.setProperty(`--${attr}`, this.getAttribute(attr) ?? null);
        });
    }

    render() {
        this.rootElement = document.createElement('div');
        this.rootElement.classList.add('rich-text-columns');
        this.setColumnsProperties(this.rootElement);

        this.rootElement.innerHTML = `
            <slot></slot>
        `;

        this.setHasSlottedToParent(this.rootElement);
        return this.rootElement;
    }

    attributeChangedCallback() {
        if (this.rootElement) {
            this.setColumnsProperties(this.rootElement);
        }
    }
}

customElements.define('nxt-rich-text-columns', NXTRichTextColumns);
